/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetOrderExecutionEmployeeDto } from './GetOrderExecutionEmployeeDto';
import {
    GetOrderExecutionEmployeeDtoFromJSON,
    GetOrderExecutionEmployeeDtoFromJSONTyped,
    GetOrderExecutionEmployeeDtoToJSON,
} from './GetOrderExecutionEmployeeDto';
import type { GetOrderExecutionPositionDto } from './GetOrderExecutionPositionDto';
import {
    GetOrderExecutionPositionDtoFromJSON,
    GetOrderExecutionPositionDtoFromJSONTyped,
    GetOrderExecutionPositionDtoToJSON,
} from './GetOrderExecutionPositionDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';

/**
 * 
 * @export
 * @interface GetOrderExecutionWithCurrencyDto
 */
export interface GetOrderExecutionWithCurrencyDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    id: string;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    resultProject: GetProjectDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    addTeamToEmails: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    emails: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    formalConditionsId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    status: GetOrderExecutionWithCurrencyDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    systemNumber: number;
    /**
     * 
     * @type {Array<GetOrderExecutionPositionDto>}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    orderExecutionPositions?: Array<GetOrderExecutionPositionDto>;
    /**
     * 
     * @type {Array<GetOrderExecutionEmployeeDto>}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    orderExecutionEmployees?: Array<GetOrderExecutionEmployeeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    rejectedNote: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    creationTs: Date;
    /**
     * 
     * @type {number}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    salesSum?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    purchaseSum?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderExecutionWithCurrencyDto
     */
    currencyCode: string;
}


/**
 * @export
 */
export const GetOrderExecutionWithCurrencyDtoStatusEnum = {
    New: 'New',
    Accepted: 'Accepted',
    Rejected: 'Rejected'
} as const;
export type GetOrderExecutionWithCurrencyDtoStatusEnum = typeof GetOrderExecutionWithCurrencyDtoStatusEnum[keyof typeof GetOrderExecutionWithCurrencyDtoStatusEnum];


/**
 * Check if a given object implements the GetOrderExecutionWithCurrencyDto interface.
 */
export function instanceOfGetOrderExecutionWithCurrencyDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "resultProject" in value;
    isInstance = isInstance && "addTeamToEmails" in value;
    isInstance = isInstance && "emails" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "formalConditionsId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "rejectedNote" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;
    isInstance = isInstance && "currencyCode" in value;

    return isInstance;
}

export function GetOrderExecutionWithCurrencyDtoFromJSON(json: any): GetOrderExecutionWithCurrencyDto {
    return GetOrderExecutionWithCurrencyDtoFromJSONTyped(json, false);
}

export function GetOrderExecutionWithCurrencyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderExecutionWithCurrencyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project': GetProjectDtoFromJSON(json['project']),
        'resultProject': GetProjectDtoFromJSON(json['resultProject']),
        'addTeamToEmails': json['addTeamToEmails'],
        'emails': json['emails'],
        'date': (new Date(json['date'])),
        'formalConditionsId': json['formalConditionsId'],
        'status': json['status'],
        'systemNumber': json['systemNumber'],
        'orderExecutionPositions': !exists(json, 'orderExecutionPositions') ? undefined : ((json['orderExecutionPositions'] as Array<any>).map(GetOrderExecutionPositionDtoFromJSON)),
        'orderExecutionEmployees': !exists(json, 'orderExecutionEmployees') ? undefined : ((json['orderExecutionEmployees'] as Array<any>).map(GetOrderExecutionEmployeeDtoFromJSON)),
        'active': json['active'],
        'rejectedNote': json['rejectedNote'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'salesSum': !exists(json, 'salesSum') ? undefined : json['salesSum'],
        'purchaseSum': !exists(json, 'purchaseSum') ? undefined : json['purchaseSum'],
        'currencyCode': json['currencyCode'],
    };
}

export function GetOrderExecutionWithCurrencyDtoToJSON(value?: GetOrderExecutionWithCurrencyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'project': GetProjectDtoToJSON(value.project),
        'resultProject': GetProjectDtoToJSON(value.resultProject),
        'addTeamToEmails': value.addTeamToEmails,
        'emails': value.emails,
        'date': (value.date.toISOString()),
        'formalConditionsId': value.formalConditionsId,
        'status': value.status,
        'systemNumber': value.systemNumber,
        'orderExecutionPositions': value.orderExecutionPositions === undefined ? undefined : ((value.orderExecutionPositions as Array<any>).map(GetOrderExecutionPositionDtoToJSON)),
        'orderExecutionEmployees': value.orderExecutionEmployees === undefined ? undefined : ((value.orderExecutionEmployees as Array<any>).map(GetOrderExecutionEmployeeDtoToJSON)),
        'active': value.active,
        'rejectedNote': value.rejectedNote,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'salesSum': value.salesSum,
        'purchaseSum': value.purchaseSum,
        'currencyCode': value.currencyCode,
    };
}

